{
  "title": "Chromatic Orb",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a diamond worth at least 50 gp)",
  "duration": "Instantaneous",
  "description": [
    "You hurl a 4-inch-diameter sphere of energy at a creature that you can see within range. You choose acid, cold, fire, lightning, poison, or thunder for the type of orb you create, and then make a ranged spell attack against the target. If the attack hits, the creature takes 3d8 damage of the type you chose.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the damage increases by 1d8 for each slot level above 1st."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "wizard"]
}
